import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Claim2CustomerI} from '../../../../../../../../interfaces/claim.interface';

@Component({
  selector: 'app-invitation-dialog',
  templateUrl: './invitation-dialog.component.html',
  styleUrls: ['./invitation-dialog.component.scss']
})
export class InvitationDialogComponent implements OnInit {

  public email: FormControl = new FormControl('', Validators.required);
  constructor(@Inject(MAT_DIALOG_DATA) public data: Claim2CustomerI) { }

  ngOnInit(): void {
  }

}
